(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-print-tracking.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-print-tracking.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const trackEvent = svs.components.analytics.trackEvent;
const selectDisplayName = svs.components.tipsen.engine.selectors.engineSelectors.selectDisplayName;
const usePrintTracking = () => {
  const displayName = useSelector(state => selectDisplayName(state));
  useEffect(() => {
    const trackAfterPrint = () => {
      trackEvent({
        category: 'nya_tipsen',
        action: 'print',
        opt_label: displayName
      });
    };
    window.addEventListener('afterprint', trackAfterPrint);
    return () => {
      window.removeEventListener('afterprint', trackAfterPrint);
    };
  }, [displayName]);
};
setGlobal('svs.components.poolBetting.hooks.usePrintTracking', usePrintTracking);

 })(window);